import {getConfig} from '@logistics-frontend/core/config/selectors'
import {CountryCode} from '@logistics-frontend/core/types'

import {Config, WithConfig} from './types'

export const getTrialConfig = (state: WithConfig) => getConfig<Config>(state).trial || {}
export const getPollingConfig = (state: WithConfig) => getConfig<Config>(state).cargo.polling
export const getNDDPackageSizesConfig = (state: WithConfig) => getConfig<Config>(state).nddPackageSizes

export const getSupportedCountries = (state: WithConfig) => getConfig<Config>(state).countries

export const getCurrencySignByCountryCode = (code: CountryCode) => (state: WithConfig) => {
  const allCountries = getSupportedCountries(state)
  return allCountries[code]?.currencySign
}
